import type { NonNullScore, Score } from "@examspark/types";

export const getNewScore = (): NonNullScore => {
  return {
    min: 0,
    max: 0,
    actual: 0,
    isScorable: true,
  };
};

export const getNewScoreNullable = (): Score => {
  return {
    min: 0,
    max: 0,
    isScorable: true,
  };
};
